// src/scoreboard/src/Scoreboard.tsx
import * as React2 from "react";

// src/scoreboard/src/Scoreboard.css.ts
var scoreboard = "Scoreboard__ggc5820";
var scorenumber = "Scoreboard__ggc5821";
var separator = "Scoreboard__ggc5822";

// src/scoreboard/src/ActivityRingProgress.tsx
import React from "react";

// src/scoreboard/src/ActivityRingProgress.css.ts
var levelValue = "ActivityRingProgress__itomgp2";
var progressBar = "ActivityRingProgress__itomgp1";
var progressBarContainer = "ActivityRingProgress__itomgp0";

// src/scoreboard/src/ActivityRingProgress.tsx
var ActivityRing = ({ progress = 0, level }) => {
  const fillStyle = {
    background: `conic-gradient(#f04061 ${progress * 360 / 100}deg, #535353 ${progress * 360 / 100}deg)`
  };
  return /* @__PURE__ */ React.createElement("div", { className: progressBarContainer }, /* @__PURE__ */ React.createElement("div", { className: progressBar, style: fillStyle }), level && /* @__PURE__ */ React.createElement("span", { className: levelValue }, "Level ", level));
};
var ActivityRingProgress_default = ActivityRing;

// src/scoreboard/src/Scoreboard.tsx
function Scoreboard({
  level = 1,
  score = 0,
  progress = 0
}) {
  return /* @__PURE__ */ React2.createElement("div", { className: scoreboard }, /* @__PURE__ */ React2.createElement("div", { className: scorenumber }, score), /* @__PURE__ */ React2.createElement("div", { className: separator }), /* @__PURE__ */ React2.createElement(ActivityRingProgress_default, { progress, level }));
}
export {
  Scoreboard as default
};
